import React from "react";
import { connect } from "react-redux";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import { get } from "lodash";
import Box from "@material-ui/core/Box";

import { fetchPost } from "../../../api/fetch";
import { setBreadcrumb } from "../../../actions/common";
import MdcForm from "./MdcForm";
import MdcNbVisits from "./MdcNbVisits";
import MdcOnSites from "./MdcOnSites";
import MdcCard3 from "./MdcCard3";
import MdcLeastPerformingZones from "./MdcLeastPerformingZones";
import MdcMap from "./MdcMap";
import MdcChart from "./MdcChart";
import MdcAutomationEfficiency from "./MdcAutomationEfficiency";
import MdcAverageTimeYard from "./MdcAverageTimeYard";
import MdcDormantTrailers from "./MdcDormantTrailers";
import { computePeriod } from "../../../utils/date";

const styles = {
  container: {
    width: "100%",
    maxHeight: "calc(100vh - 100px)",
    overflow: "auto",
  },
  gridLine1: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 12px",
  },
  gridLine2: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(638px, 1fr))",
    gridAutoRows: "460px",
    gridGap: "24px",
    padding: "12px 24px 24px",
  },
  gridLine3: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 12px",
  },
};

const MdcDashboard2 = (props) => {
  const { classes, dispatch, language } = props;
  const [data, setData] = React.useState();
  const [filters, setFilters] = React.useState();

  React.useEffect(() => {
    dispatch(
      setBreadcrumb([
        {
          name: "dashboards",
          display: false,
        },
        {
          name: I18n.get("topbar_mdcDashboard2"),
        },
      ])
    );
    console.log(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const search = async (filters) => {
    try {
      setData();

      let startDate = get(filters, ["startDate"]);
      let endDate = get(filters, ["endDate"]);
      if (get(filters, ["dateFilter"]) !== "custom") {
        [startDate, endDate] = computePeriod(get(filters, ["dateFilter"]));
      }

      let body = {
        period: {
          start: new Date(startDate).toISOString(),
          end: new Date(endDate).toISOString(),
        },
        header: {
          session_id: null,
          parent_org_id: null,
          org_id: null,
          site_id: get(filters, ["sites"]) ? get(filters, ["sites"]) : null,
          zone_id: null,
          zone_type: get(filters, ["zone_type"]) || null,
          edge_id: null,
          camera_id: null,
          profile_id: null,
          profile_type: null,
          profile_tag_id: get(filters, ["tag"]) || null,
          profile_carrier_id: get(filters, ["carrier"]) || null,
        },
      };
      setFilters(body);
      let res = await fetchPost("api/v1/es/mdc/kpi", body);
      setData(res);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Box className={classes.container}>
      <MdcForm search={search} language={language} />
      <Box className={classes.gridLine1}>
        <MdcNbVisits data={data} />
        <MdcOnSites data={data} />
        <MdcCard3 data={data} />
        <MdcLeastPerformingZones data={data} />
      </Box>
      <Box className={classes.gridLine2}>
        <MdcMap data={data} />
        <MdcChart data={data} language={language} />
      </Box>
      <Box className={classes.gridLine3}>
        <MdcAutomationEfficiency data={data} />
        <MdcAverageTimeYard data={data} />
        <MdcDormantTrailers data={data} />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(MdcDashboard2));
